(ns nosco.graphql-client
  (:require-macros nosco.graphql-client)
  (:require [ajax.core :refer [POST json-response-format]]
            [nosco.ui.errors :as errors]
            [nosco.sentry]
            [goog.object]
            [nosco.controllers :as controllers])
  (:import
   goog.net.Cookies))

(defn error-callback [query-str variables e]
  (swap! controllers/app-state
         assoc :error
         (ex-info "Graphql query error" {:query-str query-str
                                         :variables variables
                                         :error e})))

(def restore-tracing
  (delay
    (goog.object/set js/window "lacinia_tracing"
                     (.getItem js/localStorage "lacinia_tracing"))))

(defn- enable-tracing? []
  (deref restore-tracing)
  (boolean
   (goog.object/get js/window "lacinia_tracing")))

;; When the result returned by resolvers does not match the graphql schema,
;; the HTTP result is successful but the graphql response contains an :errors key.
;; We treat it as an error
(defn- callback-with-graphql-error [callback errback result]
  (if (:errors result)
    (errback {:response result})
    (callback result)))

(defn error-data-or-response-unauthenticated? [{:keys [status]}]
  (= status 401))

(defn ask-for-login! []
  (let [location (.-location js/window)
        origin (.-origin location)
        ref (subs (.-href location) (count origin))
        cookies ^js (.getInstance Cookies)]
    ;; we use this when logging in with SSO, since we can't maintain state in the URL
    ;; see nosco-app authenticate.js#setTargetUrlCookie
    (.set cookies "targetUrl" ref #js {:maxAge (* 10 60)})
    (.set cookies "nosco-login-msg" "timeout" #js {:maxAge (* 10 60)})
    (set! (.-location js/window) "/login")))

(defn query!
  ([query-str variables callback]
   (query! query-str variables callback (partial error-callback query-str variables)))
  ([query-str variables callback errback]
   (let [query-js (clj->js {:query query-str :variables variables})]
     (nosco.sentry/add-breadcrumb query-js {:type :query})
     (js/console.log "Querying" query-js))
   (POST "/graphql" {:params {:query query-str :variables variables}
                     :handler (partial callback-with-graphql-error callback errback)
                     :headers (if (enable-tracing?) {"lacinia-tracing" "true"} {})
                     :error-handler
                     (fn [error-response]
                         (if (error-data-or-response-unauthenticated? error-response)
                           (ask-for-login!)
                           (errback error-response)))
                     :format :json
                     :response-format (json-response-format {:keywords? true})})))

(defn query-promise!
  "Return a promise containg the graphql result of the query and variables.
  An optional, default third argument is an error handler function that is
  attached to the promise as a .catch"
  ([query-str variables]
   (query-promise! query-str variables errors/default-query-error-handler))
  ([query-str variables error-handler]
   (cond->
    (js/Promise.
     (fn [resolve reject]
       (query! query-str variables resolve
               (fn [r]
                 (js/console.log "rejecting query promise" r)
                 (reject r)))))
     error-handler
     (.catch error-handler))))

(defn mutation-promise!
  "Return a promise containing the graphql result of the query and variables.
  An optional, default third argument is an error handler function that is
  attached to the promise as a .catch"
  ([query-str variables]
   (mutation-promise! query-str variables errors/default-mutation-error-handler))
  ([query-str variables error-handler]
   (cond->
    (js/Promise.
     (fn [resolve reject]
       (query! query-str variables resolve
               (fn [r]
                 (js/console.log "rejecting mutation promise" r)
                 (reject r)))))
     error-handler
     (.catch error-handler))))


(defn ^:export devquery [query-str variables tracing]
  (POST "/graphql" {:params {:query query-str :variables variables}
                    :handler #(js/console.log %)
                    :headers (if tracing {"lacinia-tracing" "true"} {})
                    :error-handler #(js/console.log "ERROR" (:status %) (:response %))
                    :format :json
                    :response-format (json-response-format {:raw true})}))
